import { maxAge, minAge, required, validEmail } from './validations';

export const validations = {
  name: [required],
  dateOfBirth: [minAge(16), maxAge(120), required],
  gender: [required],
  zip_code: [required],
  hasOwnCompany: [required],
  civilStatus: [required],
  hasDependentChildren: [],
  email: [validEmail, required],
  mobile: [],
  liabilitiesDurationInYears: [],
  monthlyExpensesLiabilitiesValue: [],
  socialStatus: [required],
  bankSavingsValue: [required],
  bankInvestmentsValue: [],
  insuranceProtectionValue: [],
  businessAssetsValue: [],
  homeValue: [],
  liabilitiesValue: [],
  isPartnership: [required],
  locale: [],
  isCompleted: [],
};
